// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","todayButton":"AppCalendar_todayButton__1Ksc4"};